<template>
  <main class="home">
    <h1 tabindex="-1" ref="focusFirst" class="sr-only">
      {{ $configuration.store.name }} {{ $t('homePage') }}
    </h1>
    <WCWebAds class="my-md-3" :web-ads="$configuration.ads" v-if="$configuration.ads" />
    <WCProductRow
      class="my-md-3"
      v-for="row in getConfiguration.rows"
      :key="row.id"
      :rowId="row.id"
      :rowName="row.name"
    />
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import FocusMixin from '@/mixins/FocusMixin';
import WCProductRow from '../components/WCProductRow/WCProductRow.vue';
import WCWebAds from '../components/WCWebAds/WCWebAds.vue';

export default {
  components: { WCProductRow, WCWebAds },
  name: 'Home',
  computed: {
    ...mapGetters(['getConfiguration']),
  },
  mixins: [FocusMixin], // Mixin for main content focus via routing
};
</script>
